import React from "react";
import { UiComponents, UnoStoreHooks } from "@simulanisindia/ui";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import axios from "axios";
import { removeUserData } from "../../store/slice/userSlice";
import CustomSearch from "./CustomSearch";
import apiClient from "../../apiClient";
import { GROUP_VIEW_PERMISSION, USER_VIEW_PERMISSION } from "../../constant/permission";
import { checkAnyPermissionExist } from "../../utils/general";

const { Header: UIHeader } = UiComponents;
const { useUnoSelector } = UnoStoreHooks;

const CustomHeader = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const configData = useUnoSelector((state) => state.config);
  const userData = useUnoSelector((state) => state.user);

  const handleLogout = async () => {
    try {
      await apiClient.post(`${configData.config.UNO_URL}/api/auth/logout`, {});
      window.location.reload();
    } catch (error) {
      console.log(error);
    } finally {
      localStorage.removeItem("token");
      dispatch(removeUserData());
      navigate(`/gateway`);
    }
  };

  const handleClickProfileLink = ({ url }) => {
    navigate(url);
  };


  return (
    <>
      <UIHeader
        appLogo={null}
        showSearch={false}
        showDrawer={false}
        showThemeSwitch={false}
        logoutHandler={handleLogout}
        showAddComponent={checkAnyPermissionExist([ GROUP_VIEW_PERMISSION, USER_VIEW_PERMISSION ])}
        AddOtherComponent= { <CustomSearch /> }
        headerMenuItems={false}
        appName="Home"

        userDetails={{
          name: userData?.user?.name,
          email: userData?.user?.email,
          image: userData?.user?.avatar,
          designation: userData?.user?.designation,
        }}
        profileLinks={[
          {
            handleManageProfileClick: () => handleClickProfileLink({ url: `/manage/account/${userData?.user.uuid}` }),
            label: "Manage Your Account",
          },
        ]}
      />
    </>
  );
};

export default CustomHeader;
